// app/error.tsx
'use client'; 

import { Copy } from 'lucide-react';
import { useEffect, useState } from 'react';

import { HTFButton } from './shared/components/button/HTFButtonComponent';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    console.error("Global application error caught by boundary:", error);
  }, [error]);

  const copyErrorToClipboard = async () => {
    const errorText = `Error: ${error?.message}\n\nStack Trace:\n${error?.stack || 'No stack trace available'}`;
    try {
      await navigator.clipboard.writeText(errorText);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy error:', err);
    }
  };

  return (
    // ### CODE CHANGES START ###
    // The component is now a simple div structure. We REMOVED the incorrect <html> and <body> tags,
    // and most importantly, we are NOT rendering <SiteHeader> or <SiteFooter> to break the infinite loop.
    <div className="min-h-screen bg-surface-light flex items-center justify-center p-4">
      <div className="text-center p-8 bg-white shadow-xl rounded-lg max-w-lg mx-auto border-t-4 border-error">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          Well, this is awkward.
        </h2>
        <p className="text-gray-600 mb-8">
          An unexpected error occurred. Our team has been notified. You can try to reload the page or return to the dashboard.
        </p>
        <div className="flex justify-center gap-4">
          <HTFButton
            variant="primary"
            onClick={() => reset()}
          >
            Try Again
          </HTFButton>
          <a href="/dashboard">
            <HTFButton variant="secondary">
              Go to Dashboard
            </HTFButton>
          </a>
        </div>
        {process.env.NODE_ENV === 'development' && (
            <div className="mt-8 text-left">
              <div className="flex items-center justify-between mb-2">
                <p className="text-sm font-semibold text-gray-700">Error Details (Dev Only):</p>
                <button
                  onClick={copyErrorToClipboard}
                  className="flex items-center gap-2 px-3 py-1 text-xs bg-gray-200 hover:bg-gray-300 text-gray-700 rounded transition-colors"
                >
                  <Copy className="w-3 h-3" />
                  {copied ? 'Copied!' : 'Copy'}
                </button>
              </div>
              <pre className="mt-2 p-4 bg-gray-100 text-xs text-error rounded overflow-auto max-h-40">
                  {error?.message}
                  {error?.stack && `\n\n${error.stack}`}
              </pre>
            </div>
        )}
      </div>
    </div>
    // ### CODE CHANGES FINISH ###
  );
}
// v1
// // app/error.tsx
// 'use client';

// import { useEffect } from 'react';

// import { ErrorPage } from '@/components/error-page';
// import { SiteFooter } from '@/components/site-footer';
// import { SiteHeader } from '@/components/site-header';

// export default function GlobalError({
//   error,
//   reset,
// }: {
//   error: Error & { digest?: string };
//   reset: () => void;
// }) {
//   useEffect(() => {
//     // Log the error to an error reporting service
//     console.error('Global application error:', error);
//   }, [error]);

//   return (
//     <div className="min-h-screen bg-gray-900 text-white">
//       <SiteHeader />
      
//       <main className="container mx-auto px-4 py-20">
//         <ErrorPage 
//           title="Something Went Wrong" 
//           message="We're sorry, but something went wrong with the application. Please try refreshing the page or come back later."
//           code={error.digest || 'APP_ERROR'}
//           retry={reset}
//         />
//       </main>
      
//       <SiteFooter />
//     </div>
//   );
// } 